// extracted by mini-css-extract-plugin
module.exports = {"xCenterAbsoluteContainer":"month-year-rent-slice_xCenterAbsoluteContainer__i8x5T","planTextBlockDescription":"month-year-rent-slice_planTextBlockDescription__s3Wwm"};